import {handleAjaxError} from 'src/wp-migrate-db-pro/asset/src/js/helpers/utils';

const $ = window.jQuery;
const wpmdb = window.wpmdb;
const ajaxurl = window.ajaxurl;
const _ = window._;

export default class WPMDBBackups {
	constructor() {
		this.backups_list = {};
		this.backups_rendered = false;
	}

	ajax_spinner = '<img src="' + wpmdb.functions.get_spinner_url() + '" alt="" class="ajax-spinner general-spinner" />';

	setup(){
		if ( "false" === wpmdb_data.is_pro ) {
			return false;
		}

		document.addEventListener( 'DOMContentLoaded', () => {
			if ( window.location.hash === "#backups" ) {
				this.locationHashChanged();
			}
		} );

		if ( navigator.userAgent.match( /Trident.*rv:11\./ ) ) {
			$( 'body' ).addClass( 'ie11' );
		}

		window.onhashchange = this.locationHashChanged;
	}

	/**
	 * Wrapper for jQuery's $.ajax()
	 * @param args
	 * @returns {Promise<any>}
	 */
	async doAJAX( args ) {
		const response = await $.ajax( {
			url: ajaxurl,
			type: 'POST',
			cache: false,
			data: args
		} );

		const parsed_response = JSON.parse( response );

		return parsed_response;
	}

	/**
	 * Triggered onhashchange
	 * @returns {Promise<void>}
	 */
	locationHashChanged = async () => {
		if ( window.location.hash === "#backups" ) {
			if ( _.isEmpty( this.backups_list ) ) {
				document.getElementById( 'wpmdb-backups-container' ).innerHTML = wpmdb_strings.loading_backups + this.ajax_spinner;
			}

			const backups = await this.getBackups();
			if ( backups && 'object' === typeof backups ) {
				this.displayBackups( backups );
			}
		}
	}

	/**
	 * @returns {Promise<*>}
	 */
	async getBackups() {
		const args = {
			action: 'wpmdb_get_backups',
			nonce: wpmdb_data.nonces.get_backups
		};

		try {
			if ( !_.isEmpty( this.backups_list ) ) {
				return this.backups_list;
			}

			const parsed_response = await this.doAJAX( args );

			if ( 'undefined' !== typeof(parsed_response.status) ) {
				document.getElementById( 'wpmdb-backups-container' ).innerHTML = parsed_response.status;
				this.backups_list = parsed_response.status;
				return;
			}

			if ( 'undefined' !== typeof(parsed_response.wpmdb_error) ) {
				throw new Error( parsed_response.error_msg );
			}

			this.backups_list = parsed_response;
			return parsed_response;
		} catch ( error ) {
			document.getElementById( 'wpmdb-backups-container' ).innerHTML = '';
			this.ajaxError( wpmdb_strings.error_getting_backups, error );
		}
	}

	ajaxError( error_msg, error ) {
		const ele = document.getElementById( 'wpmdb-backups-messages' );
		const tpl = `
			<p><strong>${error_msg}</strong></p>
			<p>${error}</p>
		`;

		if ( !ele.classList.contains( 'visible' ) ) {
			ele.classList.add( 'visible' );
		}

		ele.innerHTML = tpl;
		console.error( error );
	}

	/**
	 * Renders individual backup rows
	 * @param backup
	 * @returns {string}
	 */
	render( backup ) {
		const path = backup.raw_name.replace( /\.sql/, '' );

		return `
		<ul class="backups-row" id="${path}">
			<li>${backup.modified}</li>
			<li>${backup.name}</li>
			<li><a href="#backups" class="download-backup">${wpmdb_strings.download}</a> <a href="#backups" class="delete-backup"></a></li>
		</ul>`;
	}

	displayBackups( backups ) {
		if ( this.backups_rendered ) {
			return;
		}

		const markup = `${ backups.map( this.render ).join( '' ) }`;

		document.getElementById( 'wpmdb-backups-container' ).innerHTML = markup;
		this.addListener( '.download-backup', this.ajaxGetDownloadFile );
		this.addListener( '.delete-backup', this.ajaxDeleteBackup );
		this.backups_rendered = true;
	}

	async addListener( element, method ) {
		// Add event listeners for links
		document.querySelectorAll( element ).forEach( ( ele ) => {
			ele.addEventListener( 'click', async ( event ) => {
				event.preventDefault();

				// Get path info from parent element data attritbute
				const path = event.target.parentNode.parentNode.id;
				await method.call( this, path );
				return false;
			} );
		} );
	}

	async ajaxGetDownloadFile( filePath, gzip ) {
		const args = {
			action: 'wpmdb_get_backup',
			path: filePath,
			nonce: wpmdb_data.nonces.get_backup
		};

		try {
			const parsed_response = await this.doAJAX( args );

			if ( 'undefined' !== typeof(parsed_response.wpmdb_error) ) {
				throw new Error( parsed_response.error_msg );
			}

			if( 'success' === parsed_response.status ){
				location.href = parsed_response.redirect;
			}

			return parsed_response;
		} catch ( error ) {
			this.ajaxError( wpmdb_strings.error_downloading_backup, error );
		}
	}

	async ajaxDeleteBackup( path, gzip ) {
		if ( !window.confirm( wpmdb_strings.confirm_delete_backup ) ) {
			return;
		}

		const args = {
			action: 'wpmdb_delete_backup',
			path: path,
			nonce: wpmdb_data.nonces.delete_backup
		};

		try {
			const parsed_response = await this.doAJAX( args );

			if ( 'undefined' !== typeof(parsed_response.wpmdb_error) ) {
				throw new Error( parsed_response.error_msg );
			}

			if( 'deleted' === parsed_response.status ){
				var elem = document.querySelector( `#${path}` );
				elem.classList.add( 'wpmdb-backup-deleted' );

				// Remove element from the DOM after the CSS transform is complete
				setTimeout( () => {
					elem.parentNode.removeChild( elem );
				}, 1100 )
			}

			return parsed_response;
		} catch ( error ) {
			this.ajaxError( wpmdb_strings.error_deleting_backup, error );
		}
	}
}

const wpmdb_backups = new WPMDBBackups();
wpmdb_backups.setup();




// WEBPACK FOOTER //
// ./src/wp-migrate-db-pro/asset/src/js/backups.js